import { classnames } from '@/utils/classnames/classnames';
import { cva } from '@/utils/classnames/cva';
import { BadgeVariant } from '../../types';

const useClassNames = (variant: BadgeVariant) => {
  // Colours sourced from the v0 design system reference build.
  // See https://v0-electus-style-guide.vercel.app/category for the
  // canonical visual.
  // EWM-689 (SRC-GRD-03) — the "New" badge is green, not the v0 build's blue.
  const resolveVariant = cva({
    intent: {
      'on-special': 'bg-pink-600',
      clearance: 'bg-orange-500',
      new: 'bg-green-600',
    },
  });

  const className = classnames(
    // EWM-272 — Dan v0 specifies `rounded-sm` on every badge variant
    // (`/tmp/v0-extract/src/app/product/page.tsx:173`). The shipped
    // badge had no radius; aligning here gives the corner softening
    // consistent across the catalogue.
    'inline-flex w-fit items-center rounded-sm px-2 py-0.5 text-11 font-bold uppercase tracking-wide text-white',
    resolveVariant(`intent.${variant}`) as string,
  );

  return { className };
};

export default useClassNames;
